// core imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

// component imports
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { SearchComponent } from './search/search.component';
import { Search9Component } from './search9/search9.component';
import { ResultsComponent } from './results/results.component';

// services imports
import { AuthService } from './services/auth.service';

// plugin imports
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';



@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        LoginComponent,
        SearchComponent,
        ResultsComponent,
        Search9Component
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        FontAwesomeModule], providers: [
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
